/**
 * Type for message event listeners used with addMessageListener/removeMessageListener
 */
export type MessageEventListener = (msg: MessageEvent) => void;

/**
 * Adds a generic message listener
 * @param listener function triggered when message is received
 */
export function addMessageListener(listener: MessageEventListener) {
  // Add message listener
  if (window.addEventListener) {
    window.addEventListener("message", listener, false);
  }
}

/**
 * Removes a generic message listener
 * @param listener a listener previously added by `addMessageListener`
 */
export function removeMessageListener(listener: MessageEventListener) {
  if (window.removeEventListener) {
    window.removeEventListener("message", listener, false);
  }
}

/**
 * Adds iFrame message listener
 * @param event message name sent by iFrame (e.g. `showpass.message.key`)
 * @param listener function triggered when message is received
 */
export function addIFrameMessageListener(
  event: string,
  listener: (msg: MessageEvent) => void
) {
  function listenerFn(msg: MessageEvent) {
    if (msg.data === event) {
      // Only trigger if message matches given event
      listener(msg);
    }
  }

  addMessageListener(listenerFn);
}

/**
 * Removes iFrame message listener
 * @param listener added by `addIFrameMessageListener`
 */
export function removeIFrameMessageListener(
  listener: (msg: MessageEvent) => void
) {
  // Remove iFrame message listener
  if (window.removeEventListener) {
    window.removeEventListener("message", listener, false);
  }
}
